import { outsiderApiClient } from '@/services/outsiderApiClient'

export const getRefreshToken = async ({ accessToken, refreshToken }: { refreshToken: string; accessToken: string }) => {
  return outsiderApiClient.post(
    `api/token/refresh`,
    { refresh_token: refreshToken },
    { headers: { Authorization: `Bearer ${accessToken || ''}` } },
  )
}
